module.exports = __webpack_public_path__ + "static/media/sensor6.aff6bbae.jpg";